// Global Instructions Rule Applied!

import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { PipelineStagesModelFields } from './pipeline_stages_model.ts'
import { PipelineConfigModelFields } from './pipeline_config_model.ts'
import { FIELD_KEY_PROG } from '../globals.ts'
// Pipeline Stage fields
const FIELD_STAGE_NAME = `${FIELD_KEY_PROG}${PipelineStagesModelFields.name}` as const
const FIELD_STAGE_DECISION_STATUS = `${FIELD_KEY_PROG}${PipelineStagesModelFields.decision_status}` as const

// Pipeline Config fields
const FIELD_CONFIG_ID = `${PipelineConfigModelFields.id}` as const
const FIELD_CONFIG_PIPELINE = `${PipelineConfigModelFields.pipeline}` as const
const FIELD_CONFIG_STAGE = `${PipelineConfigModelFields.stage}` as const
const FIELD_CONFIG_DEFAULT = `${PipelineConfigModelFields.default}` as const
const FIELD_CONFIG_VISIBLE_KB = `${PipelineConfigModelFields.visible_kb}` as const
const FIELD_CONFIG_DROP_OPTION_KB = `${PipelineConfigModelFields.drop_option_kb}` as const
const FIELD_CONFIG_MAX_AGE_KB = `${PipelineConfigModelFields.max_age_kb}` as const
const FIELD_CONFIG_SEQUENCE_KB = `${PipelineConfigModelFields.sequence_kb}` as const
const FIELD_CONFIG_SEQUENCE_TBL = `${PipelineConfigModelFields.sequence_tbl}` as const
const FIELD_CONFIG_VISIBLE_TBL = `${PipelineConfigModelFields.visible_tbl}` as const
const FIELD_CONFIG_DROP_OPTION_TBL = `${PipelineConfigModelFields.drop_option_tbl}` as const
const FIELD_CONFIG_MAX_AGE_TBL = `${PipelineConfigModelFields.max_age_tbl}` as const
const FIELD_CONFIG_COLOUR = `${PipelineConfigModelFields.colour}` as const
const FIELD_CONFIG_STAGE_WARN_DAYS = `${PipelineConfigModelFields.stage_warn_days}` as const
const FIELD_CONFIG_STAGE_WARN_COLOUR = `${PipelineConfigModelFields.stage_warn_colour}` as const
const FIELD_CONFIG_STAGE_CRIT_DAYS = `${PipelineConfigModelFields.stage_crit_days}` as const
const FIELD_CONFIG_STAGE_CRIT_COLOUR = `${PipelineConfigModelFields.stage_crit_colour}` as const
const FIELD_CONFIG_SHOW_AGE_COUNTERS = `${PipelineConfigModelFields.show_age_counters}` as const

export const PipelineStageEntrySchema = z
  .object({
    // Pipeline Stages fields
    [FIELD_STAGE_NAME]: z.string(),
    [FIELD_STAGE_DECISION_STATUS]: z.string().nullish(),

    // Pipeline Config fields
    [FIELD_CONFIG_ID]: z.string(),
    [FIELD_CONFIG_PIPELINE]: z.string(),
    [FIELD_CONFIG_STAGE]: z.string(),
    [FIELD_CONFIG_DEFAULT]: z.boolean().nullish(),
    [FIELD_CONFIG_VISIBLE_KB]: z.boolean().nullish(),
    [FIELD_CONFIG_DROP_OPTION_KB]: z.boolean().nullish(),
    [FIELD_CONFIG_MAX_AGE_KB]: z.number().nullish(),
    [FIELD_CONFIG_SEQUENCE_KB]: z.number().nullish(),
    [FIELD_CONFIG_SEQUENCE_TBL]: z.number().nullish(),
    [FIELD_CONFIG_VISIBLE_TBL]: z.boolean().nullish(),
    [FIELD_CONFIG_DROP_OPTION_TBL]: z.boolean().nullish(),
    [FIELD_CONFIG_MAX_AGE_TBL]: z.number().nullish(),
    [FIELD_CONFIG_COLOUR]: z.string().nullish(),
    [FIELD_CONFIG_STAGE_WARN_DAYS]: z.number().nullish(),
    [FIELD_CONFIG_STAGE_WARN_COLOUR]: z.string().nullish(),
    [FIELD_CONFIG_STAGE_CRIT_DAYS]: z.number().nullish(),
    [FIELD_CONFIG_STAGE_CRIT_COLOUR]: z.string().nullish(),
    [FIELD_CONFIG_SHOW_AGE_COUNTERS]: z.boolean().nullish()
  })
  .strict()

export const PipelineStageEntryFields = makeFieldKeys(PipelineStageEntrySchema)

export type PipelineStageEntry = z.infer<typeof PipelineStageEntrySchema>

export function validatePipelineStageEntry(
  data: unknown,
  options?: { isArray?: boolean }
): PipelineStageEntry | PipelineStageEntry[] {
  try {
    return validateWithZodSchema(PipelineStageEntrySchema, data, 'pipeline stage entry', options) as
      | PipelineStageEntry
      | PipelineStageEntry[]
  } catch (error) {
    throw new Error(`Pipeline stage entry validation failed: ${error}`)
  }
}
